var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 18.99c.164.17.444.17.602 0a.425.425 0 0 0 0-.609L4.372 5.728a.433.433 0 0 0-.616 0 .451.451 0 0 0 0 .608L16.43 18.99ZM13.716 7.101H6.771l8.852 8.852c.082-.246.123-.567.123-.895v-5.9c0-1.312-.717-2.057-2.03-2.057Zm2.83 7.136 2.338 1.99c.226.198.472.314.711.314.472 0 .786-.342.786-.854V8.982c0-.513-.314-.855-.786-.855-.24 0-.485.123-.711.315l-2.338 1.982v3.815Zm-9.885 3.33h7.329L4.746 8.332c-.102.192-.164.52-.164.848v6.323c0 1.306.766 2.065 2.078 2.065Z"
  })));
};
export default SvgVideoOff;